import { media } from '@simplywallst/ui-core';
import styled from 'styled-components';

export const TooltipName = styled('span')`
  ${(props) => props.theme.typography.tiny}
  color: ${(props) => props.theme.color.whiteRGBA(0.7)};
  border-bottom: 1px dotted ${(props) => props.theme.color.brand01};
  cursor: help;
  width: fit-content;
`;

export const TableContainer = styled('div')`
  ${media.smDown`
    padding-top: ${({ theme }) => theme.x3spacePx}px;
  `}
`;
